/** One titled group of playlists. */

import { type Component, For } from 'solid-js';
import { openPlaylist } from '../../app/browse.ts';
import type { Playlist } from '../../types/media.ts';
import { Heart } from '../icons/media.tsx';
import { ChevronRight, QueueList } from '../icons/nav.tsx';
import { Row } from './Row.tsx';
import styles from './Sheet.module.css';

export interface PlaylistListProps {
  title: string;
  items: readonly Playlist[];
}

export const PlaylistList: Component<PlaylistListProps> = (props) => (
  <>
    <div class={styles.section}>{props.title}</div>
    <For each={props.items}>
      {(item) => (
        <Row
          title={item.title}
          subtitle={item.subtitle ?? ''}
          glyph={item.icon === 'heart' ? <Heart /> : <QueueList />}
          artworkUrl={item.artworkUrl ?? null}
          tail={<ChevronRight />}
          onSelect={() => openPlaylist(item)}
        />
      )}
    </For>
  </>
);
